import BaseListagem from "components/BaseListagem";
import ModalRelatorioMetaPorUsuario from "components/modal/meta/producao/ModalRelatorioMetaPorUsuario";
import ReportEdit from "components/reports/ReportEdit";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Produto from "model/administracao/cadastro/produto/Produto";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { SplitButton } from "primereact/splitbutton";
import { useEffect, useState } from "react";
import MetaProducaoService from "service/meta/producao/MetaProducaoService";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import { converterData } from "utils/convert";
import { DateMatchModeOptions, IdMatchModeOptions, NumberMatchModeOptions, ProdutoFilterTemplate, dateRangeFilterTemplate, decimalFilterTemplate, filterApplyTemplate } from "utils/filterUtils";

const metaProducaoService = new MetaProducaoService();
const usuarioLogadoService = new UsuarioLogadoService();
export default function MetaProducaoListagem() {

    const titulo = 'Metas de produção';
    const [produtos, setProdutos] = useState<Produto[]>([]);
    const [clientes, setClientes] = useState<Pessoa[]>([]);
    const [editaRelatorio, setEditaRelatorio] = useState(false);
    const [visibleDialogRelatorios, setVisibleDialogRelatorios] = useState(false);
    const [visibleModalGerarRelatorio, setVisibleModalGerarRelatorio] = useState(false);

    useEffect(() => {
        usuarioLogadoService.getAcoesUsuarioLogado().then((resposta) => {
            if (usuarioLogadoService.usuarioTemAlgumaAcao(resposta, ["RELATORIO_META_PRODUCAO_META_POR_USUARIO"])) {
                setEditaRelatorio(true);
            }
        }).catch((err) => {
            console.error(err);
        });
    }, []);

    useEffect(() => {
        metaProducaoService.produtos().then((response) => {
            setProdutos(response);
        }).catch((err) => {
            console.error(err);
        });
        metaProducaoService.clientes().then((response) => {
            setClientes(response);
        }).catch((err) => {
            console.error(err);
        });
    }, []);

    const defaultFilters: DataTableFilterMeta = {
        produto: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        cliente: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        data: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
    }


    const clienteFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={clientes}
            onChange={(e) => options.filterCallback(e.value)}
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    const extraButtons = editaRelatorio ?
        [<SplitButton
            icon="pi pi-file-pdf"
            onClick={() => setVisibleModalGerarRelatorio(true)}
            style={{ marginRight: 8 }}
            model={[{
                label: "Alterar relatórios",
                command: () => setVisibleDialogRelatorios(true)
            }]}
        />]
        : [<Button
            type="button"
            style={{ marginRight: 8 }}
            icon="pi pi-file-pdf"
            onClick={() => setVisibleModalGerarRelatorio(true)}
        />]


    

    return (
        <>
            {visibleDialogRelatorios && <Dialog
                header="Editar relatórios"
                visible={visibleDialogRelatorios}
                style={{ width: '50vw' }}
                onHide={() => setVisibleDialogRelatorios(false)}>
                <ReportEdit nomeAcao="RELATORIO_META_PRODUCAO_META_POR_USUARIO" testarRelatorio={() => { }} titulo="Relatório de meta por usuário" />
            </Dialog>}
            {visibleModalGerarRelatorio && <ModalRelatorioMetaPorUsuario 
                visible={visibleModalGerarRelatorio} 
                onHide={() => setVisibleModalGerarRelatorio(false)} />}
            <BaseListagem ordenacao="data,DESC" service={metaProducaoService} buttonsExtra={extraButtons} urlService="/metaProducao" tituloPagina={titulo} defaultFilters={defaultFilters} showClearFilterButton nome="metaProducao" >
                <Column field="produto.nome" header="Produto" filterField="produto" filter showFilterOperator={false} showAddButton={false}
                    filterMatchModeOptions={IdMatchModeOptions} filterElement={(options) => <ProdutoFilterTemplate options={options} opcoes={produtos} />}
                    filterApply={filterApplyTemplate} />
                <Column field="cliente.nome" header="Cliente" filter filterField="cliente" showFilterOperator={false} showAddButton={false}
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={clienteFilterTemplate} />
                <Column field="data" header="Data"
                    body={(rowData) => converterData(rowData.data)}
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="data"
                    filterMatchModeOptions={DateMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={dateRangeFilterTemplate} filterMenuStyle={{ zIndex: 50 }} />
                <Column field="quantidade" header="Quantidade" filter filterField="quantidade" showFilterOperator={false} showAddButton={false} filterElement={decimalFilterTemplate}
                    filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} />
            </BaseListagem>
        </>
    )
}